import { imageProps } from "./types/imageProps";

const Image = (props: imageProps) => {
    return (
        <img {...props} alt="" />
    )
}

export default Image;